import React, { useState, useEffect, useRef } from "react";
import Select from "react-select";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import axios from "axios";
import ReportingSelect from "../ReportingSelect";
import LeaveTypeSelect from "../LeaveTypeSelect";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import ReactDOM from 'react-dom';

const EmployeeLeaveModelPopup = ({ onSave, leaveData, leaveStats, viewMode, setLeaveData, setLeaveStats }) => {
  
  const apiUrl = process.env.REACT_APP_API_URL;
  const token = localStorage.getItem("token");
  const [selectedLeaveType, setSelectedLeaveType] = useState({}); // State to store the selected leave type
  const portalRoot = document.getElementById('root');

  const [selectedDate1, setSelectedDate1] = useState(null);
  const [selectedDate2, setSelectedDate2] = useState(null);
  const [dynamicInputs, setDynamicInputs] = useState([]);
  const [leaveTypes, setLeaveTypes] = useState({});
  const [leaveReason, setLeaveReason] = useState("");
  const [formErrors, setFormErrors] = useState({});
  const [totalLeaveDays, setTotalLeaveDays] = useState(0);
  const [dependentOptions, setDependentOptions] = useState({});
  const [selectedLeaveDurations, setSelectedLeaveDurations] = useState({});
  const submitButtonRef = useRef(null);
  const dateFormat = localStorage.getItem('dateFormat') || 'MMM DD, YYYY';
  const holidays = ['2024-05-22', '2024-06-21']; // Example holiday dates
  const weekends = [0, 6]; // Saturday (6) and Sunday (0)
  const [leaveTypeId, setLeaveTypeId] = useState(null);
  const leaveTypeSelectRef = useRef(null);
  const [availableBalance, setAvailableBalance] = useState(null); // New state for balance

  const [defaultLeaveTypeId, setDefaultLeaveTypeId] = useState(null);
  const [defaultLeaveTypeLabel, setDefaultLeaveTypeLabel] = useState(null);
  const [selectedEmployeeId, setSelectedEmployeeId] = useState(null); // New state for selected employee ID
  const [selectedEmployeeLabel, setSelectedEmployeeLabel] = useState(null);

  useEffect(() => {
    if (leaveData) {
      setLeaveTypes([]); // Clear leave types on error

      setSelectedDate1(new Date(leaveData.leave_start_date));
      setSelectedDate2(new Date(leaveData.leave_end_date));
      setLeaveReason(leaveData.leave_reason);
      setDefaultLeaveTypeId(leaveData.leave_type_id)
      setDefaultLeaveTypeLabel(leaveData.leavetypename)
      // Ensure both value and label are passed to LeaveTypeChange

      LeaveTypeChange({
        value: leaveData.leave_type_id,
        label: leaveData.leavetypename,
      });
  
      setAvailableBalance(null);
      setSelectedEmployeeId(leaveData.emp_id);
      setSelectedEmployeeLabel(leaveData.empname);
  
      // Reset LeaveTypeSelect when leave data changes
      if (leaveTypeSelectRef.current) {
       // leaveTypeSelectRef.current.reset();
      }
    } else {
      setSelectedDate1(null);
      setSelectedDate2(null);
      setDynamicInputs([]);
      setLeaveReason("");
      setFormErrors({});
      setTotalLeaveDays(0);
    }
  }, [leaveData]);
  


  const isHolidayOrWeekend = (date) => {
    const dayOfWeek = moment(date).day();
    const formattedDate = moment(date).format('YYYY-MM-DD');
    return holidays.includes(formattedDate) || weekends.includes(dayOfWeek);
  };

  
  const handleLeaveTypeChange = (date, selectedOption) => {
    if (selectedOption) {
      setSelectedLeaveDurations((prevDurations) => ({
        ...prevDurations,
        [date]: selectedOption.value,  // Update only the leave duration for the specific date
      }));
    }
  };
  

  
  
  
  
  const LeaveTypeChange = (selectedOption) => {
    if (selectedOption) {
      const leaveTypeId = selectedOption.value;
      const leaveBalance = selectedOption.balance !== undefined ? selectedOption.balance : null;
  
      setAvailableBalance(leaveBalance);
      setLeaveTypes({
        value: leaveTypeId,
        label: selectedOption.label || "",
      });
    } else {
      setAvailableBalance(null);
      setLeaveTypes({});
    }
  };
  







  
  
  


  const handleDependentChange = (date, selectedOption) => {
    //alert(JSON.stringify(selectedOption));
    if (selectedOption) {
      setDependentOptions((prevOptions) => {
        const updatedDependentOptions = { ...prevOptions, [date]: selectedOption.value };
        console.log("Dependent Options after state update:", updatedDependentOptions);
        return updatedDependentOptions;
      });
    } else {
      // If no option is selected, set the dependent option to null
      setDependentOptions((prevOptions) => {
        const updatedDependentOptions = { ...prevOptions, [date]: null };
        console.log("Dependent Options after state update:", updatedDependentOptions);
        return updatedDependentOptions;
      });
    }
    // Ensure dynamic inputs are generated after the dependent option is updated
    generateDynamicInputs(selectedDate1, selectedDate2);
  };
  
  
  
  

  
  
  
  
  
  const handleDateChange1 = (date) => {
    setSelectedDate1(date);
    setFormErrors((prevErrors) => ({ ...prevErrors, selectedDate1: null }));
    if (selectedDate2) {
      generateDynamicInputs(date, selectedDate2);
    }
  };
  
  const handleDateChange2 = (date) => {
    setSelectedDate2(date);
    setFormErrors((prevErrors) => ({ ...prevErrors, selectedDate2: null }));
    if (selectedDate1) {
      generateDynamicInputs(selectedDate1, date);
    }
  };
  
  useEffect(() => {
    if (selectedDate1 && selectedDate2) {
      generateDynamicInputs(selectedDate1, selectedDate2);
    }
  }, [selectedDate1, selectedDate2, selectedLeaveDurations,dependentOptions]); // Add selectedLeaveDurations as a dependency
  
  
  
  
 
  

  const getDependentOptions = (leaveDuration) => {
    if (leaveDuration === "half-day") {
      return [
        { value: "first-half", label: "First Half" },
        { value: "second-half", label: "Second Half" }
      ];
    } else if (leaveDuration === "quarter-day") {
      return [
        { value: "1st-quarter", label: "1st Quarter" },
        { value: "2nd-quarter", label: "2nd Quarter" },
        { value: "3rd-quarter", label: "3rd Quarter" },
        { value: "4th-quarter", label: "4th Quarter" }
      ];
    }
    return [];
  };

  const isHoliday = (date) => {
    const formattedDate = moment(date).format('YYYY-MM-DD');
    return holidays.includes(formattedDate);
  };


  const isWeekend = (date) => {
    const dayOfWeek = moment(date).day();
    return dayOfWeek === 0 || dayOfWeek === 6; // Sunday (0) or Saturday (6)
  };
  

  
  
  const generateDynamicInputs = (startDate, endDate) => {
    const start = moment(startDate);
    const end = moment(endDate);
    const differenceInDays = end.diff(start, "days");
    const inputs = [];
    let totalDays = 0;
  
    for (let i = 0; i <= differenceInDays; i++) {
      const currentDate = start.clone().add(i, "days").format("YYYY-MM-DD");
      const isHolidayOrWeekendDay = isHoliday(currentDate) || isWeekend(currentDate);
      let currentLeaveDuration = isHolidayOrWeekendDay ? null : selectedLeaveDurations[currentDate] || "full-day";
      const currentDependentOption = isHolidayOrWeekendDay ? null : dependentOptions[currentDate] || null;
      const isDisabled = isHolidayOrWeekendDay ? true : false;
      const disabledLabel = isHolidayOrWeekendDay ? (isHoliday(currentDate) ? "Holiday" : "Weekend") : null;
  
      inputs.push(
        <div key={currentDate} className="row mb-3">
          <div className="col-md-4">
            <label className="col-form-label">{moment(currentDate).format(dateFormat)}</label>
          </div>
  
          <div className="col-md-4">
            {isDisabled ? (
              <input type="text" className="form-control" value={disabledLabel} readOnly />
            ) : (viewMode && leaveData ? (
              <label className="col-form-label">{getLabelForLeaveDuration(currentLeaveDuration)}</label>
            ) : (
              <Select
                options={[
                  { value: "full-day", label: "Full Day" },
                  { value: "half-day", label: "Half Day" },
                  { value: "quarter-day", label: "Quarter Day" }
                ]}
                value={{ value: currentLeaveDuration, label: getLabelForLeaveDuration(currentLeaveDuration) }}
                placeholder="Select"
                className="form-select"
                onChange={(selectedOption) => handleLeaveTypeChange(currentDate, selectedOption)}
                isDisabled={isDisabled}
                menuPlacement="auto"
                menuPosition="fixed"
                styles={{
                  menu: provided => ({
                    ...provided,
                    zIndex: 9999
                  }),
                  control: provided => ({
                    ...provided,
                    overflow: 'visible'
                  })
                }}
              />
            ))}
          </div>
  
          {!isHolidayOrWeekendDay && currentLeaveDuration !== "full-day" && (
            <div className="col-md-4">
        {viewMode && leaveData ? (
  <label className="col-form-label">
    {currentDependentOption ? getLabelForDependentOption(currentDependentOption) : "N/A"}
  </label>
) : (
  <Select
    options={getDependentOptions(currentLeaveDuration)}
    value={currentDependentOption ? { value: currentDependentOption, label: getLabelForDependentOption(currentDependentOption) } : null}
    placeholder="Select"
    className="form-select mt-2"
    onChange={(selectedOption) => handleDependentChange(currentDate, selectedOption)}
    menuPlacement="auto"
    menuPosition="fixed"
    styles={{
      menu: provided => ({
        ...provided,
        zIndex: 9999
      }),
      control: provided => ({
        ...provided,
        overflow: 'visible'
      })
    }}
  />
)}

            </div>
          )}
        </div>
      );
  
      if (!isHolidayOrWeekendDay) {
        totalDays += getLeaveDurationInDays(currentLeaveDuration, currentDependentOption);
      }
    }
  
    setDynamicInputs(inputs);
    setTotalLeaveDays(totalDays);
  };
  
  
  
  
  
  
  

  const getLabelForLeaveDuration = (leaveDuration) => {
    switch (leaveDuration) {
      case "full-day":
        return "Full Day";
      case "half-day":
        return "Half Day";
      case "quarter-day":
        return "Quarter Day";
      default:
        return "Full Day";
    }
  };
  
  const getLabelForDependentOption = (dependentOption) => {
    switch (dependentOption) {
      case "first-half":
        return "First Half";
      case "second-half":
        return "Second Half";
      case "1st-quarter":
        return "1st Quarter";
      case "2nd-quarter":
        return "2nd Quarter";
      case "3rd-quarter":
        return "3rd Quarter";
      case "4th-quarter":
        return "4th Quarter";
      default:
        return "Select";
    }
  };
  



  const getLeaveDurationInDays = (leaveDuration, dependentOption) => {
    switch (leaveDuration) {
      case "full-day":
        return 1;
      case "half-day":
        return 0.5;
      case "quarter-day":
        return 0.25;
      default:
        return 1;
    }
  };



  const handleEmployeeChange = (selectedOption) => {
    setSelectedEmployeeId(selectedOption.value); // Set the selected employee ID
    setSelectedEmployeeLabel(selectedOption.label); // Set the selected employee label
    
    setAvailableBalance(null); // Reset available balance
    setLeaveTypes({}); // Clear any previously selected leave type
  
    if (leaveTypeSelectRef.current && leaveTypeSelectRef.current.reset) {
      //leaveTypeSelectRef.current.reset(); // Reset the LeaveTypeSelect component
    }
  };
  
  


  const handleLeaveSubmit = async () => {
    const isValid = validateForm(); 
    
    
    if (availableBalance !== null && availableBalance < totalLeaveDays) {
       // errors.leaveTypes = "Insufficient leave balance";

        toast.error("Insufficient leave balance");

    }

    
    if (!isValid) {
      return;
    }
  
    const leaveDetails = generateLeaveDetails(selectedDate1, selectedDate2);
    const payload = {
      employeeid: selectedEmployeeId,
      leavetype: leaveTypes.value,
      leavedetails: leaveDetails,
      leave_reason: leaveReason,
      totalleaves: totalLeaveDays,
    };
    try {
      let response;
      if (leaveData) {
        // If leaveData exists, it means we're updating an existing leave
        response = await axios.put(`${apiUrl}/leaves/${leaveData.leave_id}`, payload, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        toast.success("Leave updated successfully");

      } else {
        // If leaveData doesn't exist, it means we're adding a new leave
        response = await axios.post(`${apiUrl}/leaves/add`, payload, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        toast.success("Leave submitted successfully");
      }
    
      const newLeaveData = response.data.leaves[0]; // Extract the leave data from the response
      onSave(newLeaveData);
    
      setSelectedDate1(null);
      setSelectedDate2(null);
      setDynamicInputs([]);
      setLeaveTypes({}); // Reset leaveTypes to initial state
      setLeaveReason("");
      setFormErrors({});
      
      // Reset LeaveTypeSelect after form submission
      if (leaveTypeSelectRef.current && leaveTypeSelectRef.current.reset) {
        //leaveTypeSelectRef.current.reset();
      }
  
      if (submitButtonRef.current) {
        submitButtonRef.current.click();
      }
    } catch (error) {
      let errorMessage = "Error submitting leave.";
      if (error.response && error.response.data && error.response.data.error) {
        errorMessage = error.response.data.error;
      }      
      toast.error(errorMessage || "Error submitting leave");
    }
  };
  

  const handleUpdateLeaveStatus = async (leaveId, newStatus) => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "Do you want to update the status of this leave?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, update it!",
      cancelButtonText: "No, cancel!",
      reverseButtons: true,
    });
  
    if (result.isConfirmed) {
      try {
        const response = await axios.put(`${apiUrl}/leaves/update-status/${leaveId}`, {
          status: newStatus,
        }, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
  
        const updatedLeave = response.data.leave;
   setLeaveData((prevData) => {
  return prevData.map((leave) =>
    Number(leave.leave_id) === Number(updatedLeave.leave_id) ? updatedLeave : leave
  );
});

  
        const { leave_type_id, leave_duration } = updatedLeave;
  
        setLeaveStats((prevStats) => {
          return prevStats.map((stat) => {
            if (stat.leave_type_id === leave_type_id) {
              return {
                ...stat,
                balance: stat.balance + leave_duration,
              };
            }
            return stat;
          });
        });
  
        toast.success("Leave status has been updated.");
  
        // Close modal
        if (submitButtonRef.current) {
          submitButtonRef.current.click();
        }
      } catch (error) {
        console.error("Caught error:", error);
  
        let errorMessage = "Failed to update leave status. Please try again later.";
        if (error.response && error.response.data && error.response.data.error) {
          errorMessage = error.response.data.error;
        }
        Swal.fire("Error!", errorMessage, "error");
      }
    }
  };
  
  


  

  const generateLeaveDetails = (startDate, endDate) => {
    const leaveDetails = [];
    const currentDate = moment(startDate);
    const lastDate = moment(endDate);
  
    while (currentDate.isSameOrBefore(lastDate, "day")) {
      const formattedDate = currentDate.format("YYYY-MM-DD");
      let leaveDuration = "full-day";
      let dependentOption = null;
  
      if (isHoliday(formattedDate)) {
        leaveDuration = "holiday";
      } else if (isWeekend(formattedDate)) {
        leaveDuration = "weekend";
      } else {
        leaveDuration = selectedLeaveDurations[formattedDate] || "full-day";
        dependentOption = dependentOptions[formattedDate] || null;
      }
  
      let dependentOptionName = dependentOption;
      if (leaveDuration === "half-day") {
        if (dependentOption === "first-half") {
          dependentOptionName = "first-half";
        } else if (dependentOption === "second-half") {
          dependentOptionName = "second-half";
        }
      } else if (leaveDuration === "quarter-day") {
        switch (dependentOption) {
          case "1st-quarter":
            dependentOptionName = "1st-quarter";
            break;
          case "2nd-quarter":
            dependentOptionName = "2nd-quarter";
            break;
          case "3rd-quarter":
            dependentOptionName = "3rd-quarter";
            break;
          case "4th-quarter":
            dependentOptionName = "4th-quarter";
            break;
          default:
            dependentOptionName = dependentOption;
            break;
        }
      }
  
      leaveDetails.push({
        date: currentDate.format(dateFormat),
        leave_duration: leaveDuration,
        dependent_option: dependentOptionName
      });
  
      currentDate.add(1, "day");
    }
  
    return leaveDetails;
  };
  


  const validateForm = () => {
    const errors = {};

    if (!selectedDate1) {
        errors.selectedDate1 = "Please select a start date";
    }

    if (!selectedDate2) {
        errors.selectedDate2 = "Please select an end date";
    }

    if (moment(selectedDate2).isBefore(selectedDate1)) {
        errors.selectedDate2 = "End date must be after start date";
    }

    if (!leaveTypes.value) {
        errors.leaveTypes = "Please select a leave type";
    }

  

    setFormErrors(errors);
    return Object.keys(errors).length === 0;
};


  return (
<div id="add_leave" className="modal custom-modal fade" role="dialog">
  <div className="modal-dialog modal-lg" style={{ margin: 0, position: "fixed", right: 0, height: "100vh", width: "70%" }} role="document">
    <div className="modal-content h-100">
      <div className="modal-header">
        <h5 className="modal-title"> Apply Leave</h5>
        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <div className="modal-body" style={{ maxHeight: "calc(100vh - 80px)", overflowY: "auto" }}>
        <div className="scrollable-container">
          {/* Conditional rendering based on viewMode */}
          {viewMode && leaveData ? (
            <div>
              {/* Code for rendering labels when viewMode is true */}

              <div className="row mb-3 row-divider">
                <div className="col-md-4">
                  <label className="col-form-label">Employee <span className="text-danger">*</span></label>
                </div>
                <div className="col-md-4">
                {leaveData.empname}
                </div>
              </div>

              <div className="row mb-3 row-divider">
                <div className="col-md-4">
                  <label className="col-form-label">Leave Type <span className="text-danger">*</span></label>
                </div>
                <div className="col-md-4">
                {leaveData.leavetypename}           </div>
                <div className="col-md-4">
                {availableBalance !== null && (
      <p>Available Balance: {availableBalance}</p>
    )}
                </div>
              </div>
              <div className="row mb-3 row-divider">
                <div className="col-md-4">
                  <label className="col-form-label">Date Requested</label>
                </div>
                <div className="col-md-4">
                  {moment(leaveData.requested_date).format(dateFormat)}
                </div>
              </div>

              <div className="row mb-3 row-divider">
                <div className="col-md-4">
                  <label className="col-form-label">Status</label>
                </div>
                <div className="col-md-4">
            
                  {leaveData && leaveData.leave_status != null ? (
                    leaveData.leave_status == 0 ? "Pending" : leaveData.leave_status == 1 ? "Approved" :leaveData.leave_status == 3 ? "Cancelled": "Rejected"
                  ) : "Unknown Status"}

                </div>
              </div>

                 <div className="row mb-3 row-divider">
                <div className="col-md-4">
                  <label className="col-form-label">From <span className="text-danger">*</span></label>
                </div>
                <div className="col-md-4">
                {moment(leaveData.leave_start_date).format(dateFormat)}
               
                </div>
              </div>
              <div className="row mb-3 row-divider">
                <div className="col-md-4">
                  <label className="col-form-label">To <span className="text-danger">*</span></label>
                </div>
                <div className="col-md-4">
                {moment(leaveData.leave_end_date).format(dateFormat)}
                </div>
              </div>


              <div className="row mb-3">
                <div className="col-md-12">
                  <div>
                    {dynamicInputs.length > 0 && (
                      <div>
                        <div style={{ backgroundColor: "#f8f9fa", padding: "15px"}} className="dynamic-input-container">
                          {/* Code for rendering dynamic inputs as input fields */}
                          {dynamicInputs.map((input, index) => (
                              <div key={index} className="pb-3 custom-row-spacing">
                                  <div className="col-md-12">{input}</div>
                              </div>
                          ))}
                        </div>
                        <div className="mb-3 row-divider-bottom" style={{ zIndex: 9999, backgroundColor: "#f8f9fa", position: "sticky", top: 0 }}>
                          <div className="col-md-12">
                            <p style={{ fontSize: "16px", fontWeight: "bold" }}>Total Leave Days: {totalLeaveDays}</p>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>

              
              <div className="row mb-3 row-divider">
                <div className="col-md-4">
                  <label className="col-form-label">Leave Reason</label>
                </div>
                <div className="col-md-8">
                {leaveData.leave_reason}
                </div>
              </div>

            </div>
            
          ) : (
            <div>
              {/* Code for rendering input fields when viewMode is false */}
              <div className="row mb-3 row-divider">
                <div className="col-md-4">
                  <label className="col-form-label">Employee <span className="text-danger">*</span></label>
                </div>
                <div className="col-md-4">
                 
                  <ReportingSelect
  value={selectedEmployeeId ? { value: selectedEmployeeId, label: selectedEmployeeLabel } : null}
  onChange={handleEmployeeChange}
/>



                </div>
              </div>
              <div className="row mb-3 row-divider">
                <div className="col-md-4">
                  <label className="col-form-label">Leave Type <span className="text-danger">*</span></label>
                </div>
                <div className="col-md-4">


<LeaveTypeSelect
  employeeId={selectedEmployeeId}
  value={defaultLeaveTypeId && defaultLeaveTypeLabel ? { value: defaultLeaveTypeId, label: defaultLeaveTypeLabel } : null}
  onChange={(selectedOption) => LeaveTypeChange(selectedOption)}
  ref={leaveTypeSelectRef}
/>


                  
                </div>
                <div className="col-md-4">
                  {availableBalance !== null && (
                    <p>Available Balance: {availableBalance}</p>
                  )}
                </div>
                {formErrors.leaveTypes && <p className="text-danger">{formErrors.leaveTypes}</p>}
              </div>
              <div className="row mb-3 row-divider">
  {/* "From" label and DatePicker */}
  <div className="col-md-4">
    <label className="col-form-label">From <span className="text-danger">*</span></label>
  </div>
  <div className="col-md-4">
    <DatePicker
      selected={selectedDate1}
      onChange={handleDateChange1}
      className="form-control datetimepicker"
      type="date"
      dateFormat="dd-MM-yyyy"
    />
    {formErrors.selectedDate1 && <p className="text-danger">{formErrors.selectedDate1}</p>}
  </div>

  {/* Merged 3rd column for both "From" and "To" */}
  <div className="col-md-4" rowSpan="2">
 
      {/* Add any content that should span across both rows */}
      <p style={{ fontSize: "16px", fontWeight: "bold" }}>Total Leave Days: {totalLeaveDays}</p>


  </div>
</div>

<div className="row mb-3 row-divider">
  {/* "To" label and DatePicker */}
  <div className="col-md-4">
    <label className="col-form-label">To <span className="text-danger">*</span></label>
  </div>
  <div className="col-md-4">
    <DatePicker
      selected={selectedDate2}
      onChange={handleDateChange2}
      className="form-control datetimepicker"
      type="date"
      dateFormat="dd-MM-yyyy"
    />
    {formErrors.selectedDate2 && <p className="text-danger">{formErrors.selectedDate2}</p>}
  </div>
</div>


              <div className="row mb-3">
                <div className="col-md-12">
                  <div>
                    {dynamicInputs.length > 0 && (
                      <div>
                        <div style={{ backgroundColor: "#f8f9fa", padding: "15px"}} className="dynamic-input-container">
                          {/* Code for rendering dynamic inputs as input fields */}
                          {dynamicInputs.map((input, index) => (
                              <div key={index} className="pb-3 custom-row-spacing">
                                  <div className="col-md-12">{input}</div>
                              </div>
                          ))}
                        </div>
          
                      </div>
                    )}
                  </div>
                </div>
              </div>

              <div className="row mb-3 row-divider">
                <div className="col-md-4">
                  <label className="col-form-label">Leave Reason</label>
                </div>
                <div className="col-md-8">
                  <textarea className="form-control" rows="3" value={leaveReason} onChange={(e) => setLeaveReason(e.target.value)}></textarea>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      <div className="modal-footer">
  {viewMode && leaveData ? (
    leaveData.leave_status === '0' ? (
      <>
        <button className="btn btn-success" onClick={() => handleUpdateLeaveStatus(leaveData.leave_id, 1)}>Approve</button>
        <button className="btn btn-danger" onClick={() => handleUpdateLeaveStatus(leaveData.leave_id, 2)}>Reject</button>
         </>
    ) : leaveData.leave_status === '1' ? (
      <>
        <button className="btn btn-danger" onClick={() => handleUpdateLeaveStatus(leaveData.leave_id, 3)}>Cancel Leave</button>
        <button className="btn btn-secondary" type="button" data-bs-dismiss="modal">
          Close
        </button>
      </>
    ) : (
      <button className="btn btn-secondary" type="button" data-bs-dismiss="modal">
        Close
      </button>
    )
  ) : (

    
    <button className="btn btn-primary" onClick={handleLeaveSubmit} type="button">
      Submit
    </button>
    

    
    
  )}
</div>


      <div style={{ display: "none" }}>
        <button ref={submitButtonRef} data-bs-dismiss="modal" aria-label="Close" type="reset">
          Submit
        </button>
      </div>
    </div>
  </div>
</div>

  );
};

export default EmployeeLeaveModelPopup;
